import { createSelector } from 'reselect'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors/index.js'
import getNameReduxUtil from 'modules/redux/utils/get-name/index.js'

export default function getNameByIdWorkoutSelector (id) {
  return createSelector(
    getByIdWorkoutSelector(id),
    workout => getNameReduxUtil(workout)
  )
}
